import { atom } from "jotai";
import { z } from "zod";
import { NODE_TYPES_TO_EXCLUDE_FROM_TOUR } from "@zapier/canvas-constants";
import { nodesAtom } from "@zapier/canvas-state";

import { nodeDescription, tourDescription } from "./tourContext";
import {
  tourStepSchema,
  renderAnnotationNodesSetter,
} from "./renderAnnotationNodesSetter";

export { renderAnnotationNodesSetter, nodeDescription };

const DESCRIPTION_MIN_CHARS = 100;
const DESCRIPTION_MAX_CHARS = 144;

export const tourToolAtom = atom((get) => {
  const nodes = get(nodesAtom);
  return {
    tour: {
      description: tourDescription(
        nodes,
        NODE_TYPES_TO_EXCLUDE_FROM_TOUR,
        DESCRIPTION_MIN_CHARS,
        DESCRIPTION_MAX_CHARS,
      ),
      parameters: z.object({
        rawTourStepsData: z.array(tourStepSchema),
      }),
      shouldInclude: () => true,
      execute: atom(
        null,
        async (get, set, { rawTourStepsData, reactFlowInstance }) => {
          set(renderAnnotationNodesSetter, {
            rawTourStepsData,
            reactFlowInstance,
          });
          return {
            content: [
              {
                type: "text",
                text: "Tour started! Use the intro panel to begin.",
              },
            ],
          };
        },
      ),
    },
  };
});
